function addArt(sectionId, sectionTitle) {
    const fileInput = document.getElementById(`upload-${sectionId}`);
    const file = fileInput.files[0];

    const combinedOverlayId = `${sectionTitle.replace(' ', '')}TextOverlay`;
    const combinedOverlay = document.getElementById(combinedOverlayId);
    const tentCanvas = document.getElementById(`${sectionTitle.replace(' ', '')}Canvas`);

    if (!combinedOverlay || !tentCanvas || !file) return;

    // Ensure center lines are present
    if (!combinedOverlay.querySelector('.center-line.horizontal')) {
        combinedOverlay.innerHTML += `
            <div class="center-line horizontal"></div>
            <div class="center-line vertical"></div>`;
    }

    // Update the combined overlay's position and size
    updateOverlayPositionAndSize(sectionTitle);
    combinedOverlay.style.display = 'flex';
    combinedOverlay.style.alignItems = 'center';
    combinedOverlay.style.justifyContent = 'center';

    const reader = new FileReader();

    reader.onload = function(e) {
        const artPreview = document.getElementById(`art-preview-${sectionId}`);
        const fileExtension = file.name.split('.').pop().toLowerCase();
        let previewElement;

        if (!['jpg', 'jpeg', 'png', 'svg'].includes(fileExtension)) {
            previewElement = `<p>Preview not available for this file type.</p>`;
            artPreview.insertAdjacentHTML('afterbegin', previewElement);
            fileInput.value = '';
            return;
        }

        const imageId = `image-${Date.now()}`;

        previewElement = `
            <div class="art-container" id="${imageId}-preview" style="position: relative; display: inline-block; margin: 5px;" draggable="true" ondragstart="onDragStart(event)" ondragover="onDragOver(event)" ondragleave="onDragLeave(event)" ondrop="onDrop(event)" ondragend="onDragEnd(event)">
                <img src="${e.target.result}" alt="Art Preview" style="max-width: 115px; height: auto;">
                <button class="remove-art" onclick="removeArt('${imageId}')">&times;</button>
                <div class="custom-dropdown2">
                    <button type="button" id="selected-image-size-${imageId}" class="custom-dropdown-button" onclick="toggleDropdown('image-size-${imageId}')">
                        Choose Size
                        <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                        </svg>
                    </button>
                    <div class="custom-dropdown-content" id="image-size-${imageId}">
                        <div onclick="selectImageSizeOption('${imageId}', 'valance-3-4', '3/4 Valance Image')">3/4 Valance Image</div>
                        <div onclick="selectImageSizeOption('${imageId}', 'valance-full', 'Full Valance Image')">Full Valance Image</div>
                        <div onclick="selectImageSizeOption('${imageId}', 'peak-partial', 'Partial Peak Image')">Partial Peak Image</div>
                        <div onclick="selectImageSizeOption('${imageId}', 'peak-full', 'Full Peak Image')">Full Peak Image</div>
                        <div onclick="selectImageSizeOption('${imageId}', 'wall', 'Wall Image')">Wall Image</div>
                    </div>
                </div>
            </div>`;

        const imageContainer = document.createElement('div');
        imageContainer.id = imageId;
        imageContainer.setAttribute('data-id', imageId);
        imageContainer.className = 'editable-art';
        imageContainer.style.position = 'absolute';
        imageContainer.style.cursor = 'move';
        imageContainer.style.transformOrigin = 'center center';

        const img = new Image();
        img.onload = function() {
            const aspectRatio = img.naturalWidth / img.naturalHeight;
            const newWidth = 100;
            const newHeight = newWidth / aspectRatio;

            imageContainer.style.width = `${newWidth}px`;
            imageContainer.style.height = `${newHeight}px`;

            imageContainer.innerHTML = `
                <img src="${e.target.result}" draggable="false" />
                <div class="dot top-left"></div>
                <div class="dot top-right"></div>
                <div class="dot bottom-left"></div>
                <div class="dot bottom-right"></div>
                <div class="dot rotate"></div>
                <div class="rotate-handle"></div>
            `;

            const imgEl = imageContainer.querySelector('img');
            imgEl.style.width = '100%';
            imgEl.style.height = '100%';
            imgEl.style.display = 'block';
            imgEl.style.pointerEvents = 'none';
            imgEl.style.userSelect = 'none';

            combinedOverlay.appendChild(imageContainer);

            const overlayRect = combinedOverlay.getBoundingClientRect();
            const containerRect = imageContainer.getBoundingClientRect();
            imageContainer.style.left = `${(overlayRect.width / 2) - (containerRect.width / 2)}px`;
            imageContainer.style.top = `${(overlayRect.height / 2) - (containerRect.height / 2)}px`;

            makeElementDraggable(imageContainer, combinedOverlay);
            makeArtResizable(imageContainer);
            makeElementRotatable(imageContainer);
        };

        img.src = e.target.result;

        artPreview.insertAdjacentHTML('afterbegin', previewElement);
        const artOrderLabel = document.getElementById(`art-order-label-${sectionId}`);
        if (artOrderLabel && artPreview.children.length > 0) {
            artOrderLabel.style.display = 'block';
        }

        fileInput.value = '';
        addSelectionListener(combinedOverlay);
    };

    reader.readAsDataURL(file);
}

function selectImageSizeOption(imageId, value, label) {
    document.getElementById(`selected-image-size-${imageId}`).innerHTML = label + `<svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
    </svg>`;

    document.getElementById(`image-size-${imageId}`).classList.remove('show');
    resizeImage(imageId, value);
}

let draggedElement = null;
let dropIndicator = null;

function syncOverlayOrder(previewContainer) {
    const overlay = document.getElementById(`${sectionsConfig[currentSection - 1].title.replace(' ', '')}TextOverlay`);
    if (!overlay) return;

    const overlayArtMap = new Map();
    const existingOverlayArts = Array.from(overlay.querySelectorAll('.editable-art'));
    existingOverlayArts.forEach(el => {
        const id = el.getAttribute('data-id');
        if (id) overlayArtMap.set(id, el);
    });

    existingOverlayArts.forEach(el => overlay.removeChild(el));

    const orderedPreviewIds = Array.from(previewContainer.children)
        .filter(child => child.id.endsWith('-preview'))
        .map(child => child.id.replace('-preview', ''));

    for (let i = orderedPreviewIds.length - 1; i >= 0; i--) {
        const id = orderedPreviewIds[i];
        const overlayEl = overlayArtMap.get(id);
        if (overlayEl) {
            overlay.appendChild(overlayEl);
        }
    }
}

function onDragStart(event) {
    draggedElement = event.currentTarget;
    draggedElement.classList.add('dragging');
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.setData('text/plain', '');

    const clone = draggedElement.cloneNode(true);
    clone.style.position = 'absolute';
    clone.style.top = '-1000px';
    clone.style.left = '-1000px';
    clone.style.width = getComputedStyle(draggedElement).width;
    document.body.appendChild(clone);

    event.dataTransfer.setDragImage(clone, 0, 0);
    setTimeout(() => document.body.removeChild(clone), 0);
}

function onDragOver(event) {
    event.preventDefault();
    const target = event.target.closest('.art-container');
    if (!target || target === draggedElement) return;

    const previewContainer = target.parentElement;
    const children = Array.from(previewContainer.children);
    const draggedIndex = children.indexOf(draggedElement);
    const targetIndex = children.indexOf(target);

    if (draggedIndex < 0 || targetIndex < 0) return;

    animateSwap(draggedElement, target);

    if (draggedIndex < targetIndex) {
        previewContainer.insertBefore(draggedElement, target.nextSibling);
    } else {
        previewContainer.insertBefore(draggedElement, target);
    }
}

function onDrop(event) {
    event.preventDefault();
    const container = event.currentTarget.parentNode;

    if (dropIndicator && draggedElement) {
        container.insertBefore(draggedElement, dropIndicator);
    }

    removeDropIndicator(event);
    if (draggedElement) {
        draggedElement.classList.remove('dragging');
        draggedElement = null;
    }
}

function onDragLeave(event) {
    removeDropIndicator(event);
}

function onDragEnd() {
    if (draggedElement) {
        draggedElement.classList.remove('dragging');
        draggedElement = null;
    }
}

function animateSwap(fromEl, toEl) {
    const fromRect = fromEl.getBoundingClientRect();
    const toRect = toEl.getBoundingClientRect();

    const deltaX = fromRect.left - toRect.left;
    const deltaY = fromRect.top - toRect.top;

    toEl.style.transition = 'transform 200ms ease';
    toEl.style.transform = `translate(${deltaX}px, ${deltaY}px)`;

    requestAnimationFrame(() => {
        toEl.style.transform = 'translate(0, 0)';
    });

    toEl.addEventListener('transitionend', function handleTransitionEnd() {
        toEl.style.transition = '';
        toEl.style.transform = '';
        toEl.removeEventListener('transitionend', handleTransitionEnd);
    });
}

function removeDropIndicator(event) {
    if (dropIndicator && dropIndicator.parentNode) {
        dropIndicator.parentNode.removeChild(dropIndicator);
        dropIndicator = null;
    }

    if (event?.currentTarget?.parentNode) {
        syncOverlayOrder(event.currentTarget.parentNode);
    }
}

function makeArtResizable(element) {
    const handles = {
        'top-left': element.querySelector('.dot.top-left'),
        'top-right': element.querySelector('.dot.top-right'),
        'bottom-left': element.querySelector('.dot.bottom-left'),
        'bottom-right': element.querySelector('.dot.bottom-right')
    };

    const img = element.querySelector('img');
    if (!img) return;

    const aspectRatio = img.naturalWidth / img.naturalHeight;

    let isResizing = false;
    let activeHandle = null;

    let startX = 0;
    let startY = 0;
    let startWidth = 0;
    let startHeight = 0;
    let startLeft = 0;
    let startTop = 0;

    function onMouseDown(e, handleName) {
        e.preventDefault();
        e.stopPropagation();

        isResizing = true;
        activeHandle = handleName;

        startX = e.clientX;
        startY = e.clientY;

        startWidth = element.offsetWidth;
        startHeight = element.offsetHeight;
        startLeft = parseFloat(element.style.left) || 0;
        startTop = parseFloat(element.style.top) || 0;

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        window.addEventListener('blur', onMouseUp);
    }

    function onMouseMove(e) {
        if (!isResizing) return;

        const dx = e.clientX - startX;

        let newWidth = startWidth;
        let newHeight = startHeight;
        let newLeft = startLeft;
        let newTop = startTop;

        switch (activeHandle) {
            case 'top-left':
                newWidth = startWidth - dx;
                newHeight = newWidth / aspectRatio;
                newLeft = startLeft + dx;
                newTop = startTop + (startHeight - newHeight);
                break;

            case 'top-right':
                newWidth = startWidth + dx;
                newHeight = newWidth / aspectRatio;
                newTop = startTop + (startHeight - newHeight);
                break;

            case 'bottom-left':
                newWidth = startWidth - dx;
                newHeight = newWidth / aspectRatio;
                newLeft = startLeft + dx;
                break;

            case 'bottom-right':
                newWidth = startWidth + dx;
                newHeight = newWidth / aspectRatio;
                break;
        }

        if (newWidth > 10 && newHeight > 10) {
            element.style.width = `${newWidth}px`;
            element.style.height = `${newHeight}px`;
            element.style.left = `${newLeft}px`;
            element.style.top = `${newTop}px`;
        }
    }

    function onMouseUp() {
        isResizing = false;
        activeHandle = null;
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        window.removeEventListener('blur', onMouseUp);
    }

    Object.entries(handles).forEach(([name, handle]) => {
        if (!handle) return;
        handle.addEventListener('mousedown', (e) => onMouseDown(e, name));
    });
}

function makeElementRotatable(element) {
    const rotateHandle = element.querySelector('.dot.rotate');
    if (!rotateHandle) return;

    let isRotating = false;
    const snapAngles = [0, 90, 180, 270, 360];
    const snapThreshold = 6;

    function getElementCenter(el) {
        const rect = el.getBoundingClientRect();
        return {
            x: rect.left + rect.width / 2,
            y: rect.top + rect.height / 2
        };
    }

    function getAngle(centerX, centerY, mouseX, mouseY) {
        return Math.atan2(mouseY - centerY, mouseX - centerX) * (180 / Math.PI);
    }

    function normalizeAngle(angle) {
        let normalized = angle % 360;
        if (normalized < 0) normalized += 360;
        return normalized;
    }

    function snapRotation(angle) {
        const normalized = normalizeAngle(angle);

        for (const snap of snapAngles) {
            if (Math.abs(normalized - snap) <= snapThreshold) {
                return snap === 360 ? 0 : snap;
            }
        }

        return normalized;
    }

    function onMouseDown(e) {
        e.preventDefault();
        e.stopPropagation();

        isRotating = true;
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        window.addEventListener('blur', onMouseUp);
    }

    function onMouseMove(e) {
        if (!isRotating) return;

        const center = getElementCenter(element);
        const rawAngle = getAngle(center.x, center.y, e.clientX, e.clientY) + 90;
        const finalAngle = snapRotation(rawAngle);

        element.dataset.rotation = finalAngle;
        element.style.transform = `rotate(${finalAngle}deg)`;
    }

    function onMouseUp() {
        isRotating = false;
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        window.removeEventListener('blur', onMouseUp);
    }

    rotateHandle.addEventListener('mousedown', onMouseDown);
}

function makeElementDraggable(element, container) {
    let isMouseDown = false;
    let isDragging = false;
    let startMouseX = 0;
    let startMouseY = 0;
    let startLeft = 0;
    let startTop = 0;

    const dragThreshold = 5;
    const snapThreshold = 10;

    function onMouseDown(e) {
        if (e.button !== 0) return;
        if (e.target.closest('.dot')) return;

        e.preventDefault();

        startMouseX = e.clientX;
        startMouseY = e.clientY;
        startLeft = parseFloat(element.style.left) || 0;
        startTop = parseFloat(element.style.top) || 0;

        isMouseDown = true;
        isDragging = false;

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        window.addEventListener('blur', onMouseUp);
    }

    function onMouseMove(e) {
        if (!isMouseDown) return;

        const movedX = Math.abs(e.clientX - startMouseX);
        const movedY = Math.abs(e.clientY - startMouseY);

        if (!isDragging && (movedX > dragThreshold || movedY > dragThreshold)) {
            isDragging = true;
        }

        if (!isDragging) return;

        e.preventDefault();

        let newX = startLeft + (e.clientX - startMouseX);
        let newY = startTop + (e.clientY - startMouseY);

        const containerRect = container.getBoundingClientRect();
        const elementCenterX = newX + element.offsetWidth / 2;
        const elementCenterY = newY + element.offsetHeight / 2;
        const containerCenterX = containerRect.width / 2;
        const containerCenterY = containerRect.height / 2;

        if (snapGridEnabled) {
            const isSnappedX = Math.abs(elementCenterX - containerCenterX) < snapThreshold;
            const isSnappedY = Math.abs(elementCenterY - containerCenterY) < snapThreshold;

            if (isSnappedX) {
                showCenterLine(container, 'vertical');
                newX = containerCenterX - element.offsetWidth / 2;
            } else {
                hideCenterLine(container, 'vertical');
            }

            if (isSnappedY) {
                showCenterLine(container, 'horizontal');
                newY = containerCenterY - element.offsetHeight / 2;
            } else {
                hideCenterLine(container, 'horizontal');
            }
        }

        element.style.left = `${newX}px`;
        element.style.top = `${newY}px`;
    }

    function onMouseUp() {
        isMouseDown = false;
        isDragging = false;
        hideCenterLines(container);

        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        window.removeEventListener('blur', onMouseUp);
    }

    element.addEventListener('mousedown', onMouseDown);
}

function removeArt(imageId) {
    const previewElement = document.getElementById(`${imageId}-preview`);
    const canvasElement = document.getElementById(imageId);

    if (previewElement) previewElement.remove();
    if (canvasElement) canvasElement.remove();

    const artPreview = document.getElementById(`art-preview-${sectionsConfig[currentSection - 1].id}`);
    const artOrderLabel = document.getElementById(`art-order-label-${sectionsConfig[currentSection - 1].id}`);
    if (artOrderLabel && artPreview.children.length === 0) {
        artOrderLabel.style.display = 'none';
    }
}

function validateFileInput(event, sectionId) {
    const fileInput = event.target;
    const filePath = fileInput.value;
    const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.svg)$/i;

    if (filePath) {
        if (!allowedExtensions.exec(filePath)) {
            showUploadModal();
            fileInput.value = '';
            return false;
        }
    }
}

document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', (e) => {
        const buttons = ['snapGrid', 'horizCenter', 'vertCenter'];
        if (!buttons.includes(e.target.id)) {
            let itemSelected = false;
            document.querySelectorAll('.editable-text, .editable-art').forEach(el => {
                if (!el.contains(e.target)) {
                    el.classList.remove('selected');
                    el.classList.remove('selected2');
                } else {
                    itemSelected = true;
                }
            });
            toggleCenterButtons(itemSelected);
        }
    });

    let copiedArt = null;

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Delete') {
            const selectedElement = document.querySelector('.editable-art.selected, .editable-art.selected2');
            if (selectedElement) {
                const imageId = selectedElement.getAttribute('data-id');
                removeArt(imageId);
            }
        }

        if ((e.key === 'c' || e.key === 'C') && (e.ctrlKey || e.metaKey)) {
            const selectedArt = document.querySelector('.editable-art.selected, .editable-art.selected2');
            if (selectedArt) {
                copiedArt = selectedArt.cloneNode(true);
            }
        }

        if ((e.key === 'v' || e.key === 'V') && (e.ctrlKey || e.metaKey) && copiedArt) {
            const sectionId = sectionsConfig[currentSection - 1].id;
            const sectionTitle = sectionsConfig[currentSection - 1].title;
            const combinedOverlay = document.getElementById(`${sectionTitle.replace(' ', '')}TextOverlay`);
            if (!combinedOverlay) return;

            const newArt = copiedArt.cloneNode(true);
            const newId = `image-${Date.now()}`;
            newArt.id = newId;
            newArt.setAttribute('data-id', newId);
            newArt.classList.add('editable-art');
            newArt.style.position = 'absolute';
            newArt.style.cursor = 'move';
            newArt.style.left = `${(parseInt(copiedArt.style.left) || 0) + 10}px`;
            newArt.style.top = `${(parseInt(copiedArt.style.top) || 0) + 10}px`;

            combinedOverlay.appendChild(newArt);

            makeElementDraggable(newArt, combinedOverlay);
            makeArtResizable(newArt);
            makeElementRotatable(newArt);
            addSelectionListener(combinedOverlay);

            const previewImg = copiedArt.querySelector('img');
            const previewSrc = previewImg ? previewImg.src : '';

            const artPreview = document.getElementById(`art-preview-${sectionId}`);
            if (artPreview) {
                const previewElement = `
                    <div class="art-container" id="${newId}-preview" style="position: relative; display: inline-block; margin: 5px;" draggable="true" ondragstart="onDragStart(event)" ondragover="onDragOver(event)" ondragleave="onDragLeave(event)" ondrop="onDrop(event)" ondragend="onDragEnd(event)">
                        <img src="${previewSrc}" alt="Art Preview" style="max-width: 115px; height: auto;">
                        <button class="remove-art" onclick="removeArt('${newId}')">&times;</button>
                        <div class="custom-dropdown2">
                            <button type="button" id="selected-image-size-${newId}" class="custom-dropdown-button" onclick="toggleDropdown('image-size-${newId}')">
                                Choose Size
                                <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                                </svg>
                            </button>
                            <div class="custom-dropdown-content" id="image-size-${newId}">
                                <div onclick="selectImageSizeOption('${newId}', 'valance-3-4', '3/4 Valance Image')">3/4 Valance Image</div>
                                <div onclick="selectImageSizeOption('${newId}', 'valance-full', 'Full Valance Image')">Full Valance Image</div>
                                <div onclick="selectImageSizeOption('${newId}', 'peak-partial', 'Partial Peak Image')">Partial Peak Image</div>
                                <div onclick="selectImageSizeOption('${newId}', 'peak-full', 'Full Peak Image')">Full Peak Image</div>
                                <div onclick="selectImageSizeOption('${newId}', 'wall', 'Wall Image')">Wall Image</div>
                            </div>
                        </div>
                    </div>`;
                artPreview.insertAdjacentHTML('afterbegin', previewElement);

                const artOrderLabel = document.getElementById(`art-order-label-${sectionId}`);
                if (artOrderLabel && artPreview.children.length > 0) {
                    artOrderLabel.style.display = 'block';
                }
            }
        }
    });
});

function addSelectionListener(overlay) {
    overlay.addEventListener('click', (e) => {
        let target = e.target;
        while (target && target !== overlay) {
            if (target.classList.contains('editable-art') || target.classList.contains('editable-text')) {
                e.stopPropagation();
                document.querySelectorAll('.editable-text, .editable-art').forEach(el => {
                    el.classList.remove('selected');
                    el.classList.remove('selected2');
                });

                const textOverlay = target.closest('.text-overlay');
                if (textOverlay) {
                    const canvasId = textOverlay.id.replace('TextOverlay', 'Canvas');
                    const canvas = document.getElementById(canvasId);
                    if (canvas) {
                        const context = canvas.getContext('2d');
                        const canvasColor = context.fillStyle;
                        let flag = 0;

                        switch (canvasColor) {
                            case '#ffffff':
                            case '#c2c2c2':
                            case '#c0c494':
                            case '#ffbd0d':
                            case '#fce60d':
                                target.classList.add('selected');
                                toggleCenterButtons(true);
                                flag = 1;
                                break;
                            case '#060808':
                            case '#8d8c8c':
                            case '#552132':
                            case '#862838':
                            case '#c52c2c':
                            case '#da4b12':
                            case '#344e30':
                            case '#1b234b':
                            case '#73519e':
                            case '#2f5fa7':
                            case '#44b15c':
                            case '#8fa9dd':
                                target.classList.add('selected2');
                                toggleCenterButtons(true);
                                flag = 1;
                                break;
                        }

                        if (flag === 0) {
                            const rgb = hexToRgb(canvasColor);
                            const brightness = Math.sqrt(
                                0.299 * (rgb.r * rgb.r) +
                                0.587 * (rgb.g * rgb.g) +
                                0.114 * (rgb.b * rgb.b)
                            );

                            if (brightness > 150) {
                                target.classList.add('selected');
                            } else {
                                target.classList.add('selected2');
                            }
                        }
                    }
                }

                toggleCenterButtons(true);
                return;
            }
            target = target.parentElement;
        }
    });
}

function hexToRgb(hex) {
    hex = hex.replace(/^#/, '');

    if (hex.length === 3) {
        hex = hex.split('').map(char => char + char).join('');
    }

    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return { r, g, b };
}

function resizeImage(imageId, selectedSize) {
    const imageContainer = document.getElementById(imageId);
    if (!imageContainer) return;

    const img = imageContainer.querySelector('img');
    if (!img) return;

    const sectionTitle = sectionsConfig[currentSection - 1].title;
    const combinedOverlayId = `${sectionTitle.replace(' ', '')}TextOverlay`;
    const combinedOverlay = document.getElementById(combinedOverlayId);

    let containerHeight;
    switch (selectedSize) {
        case 'valance-3-4':
            containerHeight = 20;
            break;
        case 'valance-full':
            containerHeight = 27;
            break;
        case 'peak-partial':
            containerHeight = 40;
            break;
        case 'peak-full':
            containerHeight = 70;
            break;
        case 'wall':
            containerHeight = 100;
            break;
        default:
            containerHeight = img.naturalHeight;
            break;
    }

    const aspectRatio = img.naturalWidth / img.naturalHeight;
    const containerWidth = containerHeight * aspectRatio;

    imageContainer.style.height = `${containerHeight}px`;
    imageContainer.style.width = `${containerWidth}px`;

    const overlayRect = combinedOverlay.getBoundingClientRect();
    const containerRect = imageContainer.getBoundingClientRect();

    const centeredLeft = (overlayRect.width / 2) - (containerRect.width / 2);
    const centeredTop = (overlayRect.height / 2) - (containerRect.height / 2);

    imageContainer.style.left = `${centeredLeft}px`;
    imageContainer.style.top = `${centeredTop}px`;
}